/* eslint-disable test-selectors/onClick */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-duplicates */
import { useCallback, useEffect, useRef, useState } from 'react';

import cn from 'classnames';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';
import { Link, NavLink, useLocation } from 'react-router-dom';

// import twentyFivePercentIcon from 'styles/assets/twentyFivePercent.svg';
import { setMarketsSelectedTab } from 'actions/markets';
import { isAuthenticated } from 'actions/user';
// import SearchBox from 'components/Header/partials/headerDropdown/SearchBox';
import Render from 'components/render';
import {
  RenderForGlobalExchange,
  RenderForIndianExchange,
} from 'components/render/RenderByExchangeType';
import OptionsCombosSlides from 'components/trade/OptionsCombos/Slides';
import { STORAGE_KEYS } from 'constants/enums';
import routes from 'constants/routes';
import Popover from 'containers/Popover';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { device } from 'helpers/screenSizes';
import { preLoginFavoriteClick } from 'helpers/utils';
import useLocalStorage from 'hooks/useLocalStorage';
import useToggle from 'hooks/useToggle';
import useWindowSize from 'hooks/useWindowSize';
import { useAppDispatch } from 'storeHooks';
import { FavoriteSelected, SearchIcon } from 'styles/assets/icons';
import Box from 'UIKit/Box';
import DeltaButton from 'UIKit/DeltaButton';

import styles from './index.module.scss';
import SearchMarkets from '../../search';
import FuturesVolumeBox from '../24HourVolumeBox/FuturesVolumeBox';
import OptionsVolumeBox from '../24HourVolumeBox/OptionsVolumeBox';
import DownloadVolumeData from '../DownloadVolumeData/DownloadVolumeData';

const TAB_LIST = {
  FAVORITES: 'favorites',
  ROBO_STRATEGIES: 'robo strategies',
  FUTURES: 'futures',
  OPTIONS: 'options',
  SPOT: 'spot',
  TRACKER: 'tracker',
  MOVE: 'MOVE',
  SPREADS: 'spreads',
  IRS: 'interest rate swaps',
  OPTIONS_COMBOS: 'options combos',
  OPTIONS_ANALYTICS: 'options analytics',
};

const TAB_LIST_URL_PARAM = {
  [TAB_LIST.FAVORITES]: 'favorites',
  [TAB_LIST.ROBO_STRATEGIES]: 'robo-strategies',
  [TAB_LIST.FUTURES]: 'futures',
  [TAB_LIST.OPTIONS]: 'options_chain',
  [TAB_LIST.SPOT]: 'spot',
  [TAB_LIST.TRACKER]: 'tracker',
  [TAB_LIST.MOVE]: 'move_options',
  [TAB_LIST.SPREADS]: 'spreads',
  [TAB_LIST.IRS]: 'interest_rate_swaps',
  [TAB_LIST.OPTIONS_COMBOS]: 'options_combos',
  [TAB_LIST.OPTIONS_ANALYTICS]: 'options_analytics',
};

const OPTION_ANALYTICS_LABEL = i18next.t(
  'headerFooter:header.moreMenu.optionAnalytics.label'
);

const MarketsContractTypeHeader = props => {
  const {
    // showFunds,
    onSearchChange,
    searchTerm,
    noProducts,
    handleOnClick,
    reset,
    contractType,
  } = props;
  const { t } = useTranslation(['markets', 'headerFooter']);
  const isActive = path => (_, location) => location.pathname.includes(path);
  const { isMobile } = useWindowSize();
  const isLoggedIn = useSelector(({ user }) => isAuthenticated(user));
  const dispatch = useAppDispatch();

  // const clearSearch = () => {
  //   document.getElementById('searchInput').value = '';
  //   onSearchChange('');
  // };

  const onTabClick = tabName => {
    dispatch(setMarketsSelectedTab(TAB_LIST_URL_PARAM[tabName]));
    if (tabName === TAB_LIST.TRACKER) {
      trackMixpanelEvent('Tracker Tab Clicked - Markets - Product Table', {
        tab_name: tabName,
        is_mobile_app: isMobile,
      });
    }
  };

  const headerElement = useRef();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isOptionSlidesShown, setIsOptionsSlidesShown] = useLocalStorage(
    STORAGE_KEYS.OPTION_COMBOS_SLIDES,
    false
  );
  const [isOptionsCombosSlideModalOpen, setOptionsCombosSlideModalOpen] = useState(false);

  const [hasAutoScrolled, setHasAutoScrolled] = useToggle();

  const optionsCombosSlidesModalClose = () => {
    setOptionsCombosSlideModalOpen(false);
  };

  const handleAutoScroll = useCallback(() => {
    window.scrollTo({
      top: (headerElement.current?.offsetTop ?? 0) - 50, //  50 denoting primaryHeader height
    });

    if (!hasAutoScrolled) {
      if (isOptionSlidesShown) return;
      setIsOptionsSlidesShown(true);
      setOptionsCombosSlideModalOpen(true);
      setHasAutoScrolled();
    }
  }, [hasAutoScrolled, isOptionSlidesShown, setHasAutoScrolled, setIsOptionsSlidesShown]);

  const location = useLocation();

  const [hasOptionsCombosHit, setHasOptionsCombosHit] = useState(false);

  useEffect(() => {
    function handlePerformAutoScroll() {
      if (
        (!location.state?.ignoreAutoScroll && hasOptionsCombosHit) ||
        (!hasOptionsCombosHit &&
          !location.state?.ignoreAutoScroll &&
          location.pathname === routes.optionsCombos.markets) ||
        (hasOptionsCombosHit && location.pathname === routes.optionsCombos.markets)
      ) {
        setHasOptionsCombosHit(true);
        handleAutoScroll();
      }
    }

    handlePerformAutoScroll();
  }, [
    handleAutoScroll,
    hasOptionsCombosHit,
    location.pathname,
    location.state?.ignoreAutoScroll,
  ]);

  return (
    (<div
      ref={headerElement}
      className={styles[`tab-search-header`]}
      data-palette="MarketsContractTypeHeader">
      <Render when={isOptionsCombosSlideModalOpen}>
        <OptionsCombosSlides
          isModalOpen={isOptionsCombosSlideModalOpen}
          handleModalClose={optionsCombosSlidesModalClose}
        />
      </Render>
      {/* Tabs & Search */}
      <Box className={styles.tabSearchContainer} id="mobile-top-tabs-container">
        <div className={styles[`tab-bar`]}>
          {/* Favorites Tab */}
          <NavLink
            data-testid="Watchlist-MarketsPage"
            activeClassName={styles['active-header-link']}
            isActive={isActive(routes.favorites.markets)}
            className={cn(styles[`favourites-tab`], styles[`tab-bar-item`])}
            // to={isLoggedIn && routes.favorites.markets}
            to={isLoggedIn ? routes.favorites.markets : ''}
            onClick={() => isLoggedIn && onTabClick(TAB_LIST.FAVORITES)}
          >
            <Render
              when={isLoggedIn}
              else={
                <Popover
                  body={<Trans i18nKey="trading:seeWatchlistToolTip" />}
                  shouldEnableClickListener
                >
                  {thisProps => (
                    <Box
                      as="span"
                      data-testid="Watchlist-MarketsPage"
                      onClick={e => preLoginFavoriteClick(e, thisProps.setOpen)}
                    >
                      {/* <MediaQuery query={device.down.md}>
                      <FavoriteSelected className={styles['favorite-mobile-icon']} />
                    </MediaQuery> */}
                      {!isMobile ? (
                        <span data-palette="MarketsContractTypeHeader">{t('markets:contractHeader.watchlist')}</span>
                      ) : (
                        <>
                          <RenderForIndianExchange>
                            <span>{t('markets:contractHeader.watchlist')}</span>
                          </RenderForIndianExchange>
                          <RenderForGlobalExchange>
                            <FavoriteSelected className={styles['fav-icon']} />
                          </RenderForGlobalExchange>
                        </>
                      )}
                    </Box>
                  )}
                </Popover>
              }
            >
              <span className={styles.titleSpacing}>
                {/* <MediaQuery query={device.down.md}>
                <FavoriteSelected className={styles['favorite-mobile-icon']} />
              </MediaQuery> */}

                {!isMobile ? (
                  <span data-palette="MarketsContractTypeHeader">{t('markets:contractHeader.watchlist')}</span>
                ) : (
                  <>
                    <RenderForIndianExchange>
                      <span>{t('markets:contractHeader.watchlist')}</span>
                    </RenderForIndianExchange>
                    <RenderForGlobalExchange>
                      <FavoriteSelected className={styles['fav-icon']} />
                    </RenderForGlobalExchange>
                  </>
                )}
              </span>
              <span
                className={cn({
                  [styles.indicator]: !isMobile,
                  [styles['fav-icon-loggedin-indicator']]: isMobile,
                })}
              />
            </Render>
          </NavLink>

          {/* Options Tab */}
          <NavLink
            data-testid="OptionsTab-MarketsPage"
            activeClassName={styles['active-header-link']}
            isActive={isActive(routes.options_chain.markets)}
            className={cn(styles.optionsChain, styles[`tab-bar-item`], 'relative')}
            to={routes.options_chain.markets}
            onClick={() => onTabClick(TAB_LIST.OPTIONS)}
          >
            <span className={styles.titleSpacing}>
              {t('markets:contractHeader.options')}
            </span>
            <span className={styles.indicator} />
          </NavLink>

          {/* Futures Tab */}
          <NavLink
            data-testid="FuturesTab-MarketsPage"
            activeClassName={styles['active-header-link']}
            isActive={isActive(routes.futures.markets)}
            className={cn(styles.futures, styles[`tab-bar-item`], 'relative')}
            to={routes.futures.markets}
            onClick={() => onTabClick(TAB_LIST.FUTURES)}
          >
            <span className={styles.titleSpacing}>
              {t('markets:contractHeader.futures')}
            </span>
            <span className={styles.indicator} />
          </NavLink>
          <RenderForIndianExchange>
            {/* Tracker Tab */}
            <NavLink
              data-testid="tracker-MarketsPage"
              activeClassName={styles['active-header-link']}
              className={cn(styles.tracker, styles[`tab-bar-item`], 'relative')}
              isActive={isActive(routes.tracker.markets)}
              to={{
                pathname: routes.tracker.markets,
                state: { ignoreAutoScroll: true },
              }}
              onClick={() => onTabClick(TAB_LIST.TRACKER)}
            >
              <span className={styles.titleSpacing}>
                {t('markets:contractHeader.tracker')}
              </span>

              {/* <Tag text="200x" className={styles[`new-tag`]} /> */}
              <span className={styles.indicator} />
            </NavLink>

            {/* Option Analytics Tab */}
            <NavLink
              data-testid="optionAnalyticsTab-MarketsPage"
              activeClassName={styles['active-header-link']}
              className={cn(styles.spot, styles[`tab-bar-item`], 'relative')}
              isActive={isActive(routes.optionAnalytics.markets)}
              to={routes.optionAnalytics.markets}
              onClick={() => onTabClick(TAB_LIST.OPTIONS_ANALYTICS)}
            >
              <span className={styles.titleSpacing}>{OPTION_ANALYTICS_LABEL}</span>
              <span className={styles.indicator} />
            </NavLink>
          </RenderForIndianExchange>

          <RenderForGlobalExchange>
            <>
              {/* Spot Tab */}
              <NavLink
                data-testid="spotTab-MarketsPage"
                activeClassName={cn(
                  styles['active-header-link'],
                  styles[`zero-fee-link`]
                )}
                className={cn(styles.spot, styles[`tab-bar-item`], 'relative')}
                isActive={isActive(routes.spot.markets)}
                to={routes.spot.markets}
                onClick={() => onTabClick(TAB_LIST.SPOT)}
              >
                <div className={styles['zero-fee-tag-wrapper']}>
                  <span className={styles.titleSpacing}>
                    {t('markets:contractHeader.spot')}
                  </span>
                </div>
                <span className={styles.indicator} />
              </NavLink>

              <NavLink
                data-testid="optionAnalyticsTab-MarketsPage"
                activeClassName={styles['active-header-link']}
                className={cn(styles.spot, styles[`tab-bar-item`], 'relative')}
                isActive={isActive(routes.optionAnalytics.markets)}
                to={routes.optionAnalytics.markets}
                onClick={() => onTabClick(TAB_LIST.OPTIONS_ANALYTICS)}
              >
                <span className={styles.titleSpacing}>{OPTION_ANALYTICS_LABEL}</span>
                <span className={styles.indicator} />
              </NavLink>

              {/* Robo-Strategies Tab */}
              {/* <NavLink
          data-testid="RoboStrategiesTab-MarketsPage"
          activeClassName={styles['active-header-link']}
          isActive={isActive(routes.robo_strategies.markets)}
          className={cn(styles[`robo-strategies`], styles[`tab-bar-item`], 'relative')}
          to={routes.robo_strategies.markets}
          onClick={() => onTabClick(TAB_LIST.ROBO_STRATEGIES)}
        >
          <span className={styles.titleSpacing}>
            {t('markets:contractHeader.roboStrategies')}
          </span>
          <span className={styles.indicator} />
        </NavLink> */}

              {/* <NavLink
          activeClassName={styles['active-header-link']}
          className={cn(styles.spreads, styles[`tab-bar-item`])}
          isActive={isActive(routes.spreads.markets)}
          to={routes.spreads.markets}
          onClick={() => onTabClick(TAB_LIST.SPREADS)}>
          <span>{t('markets:contractHeader.spreads')}</span>
        </NavLink> */}

              {/* <NavLink
          activeClassName={styles['active-header-link']}
          className={cn(styles.irs, styles[`tab-bar-item`])}
          isActive={isActive(routes.irs.markets)}
          to={routes.irs.markets}
          onClick={() => onTabClick(TAB_LIST.IRS)}>
          <Media query={device.up.md}>
            <span>{t('markets:contractHeader.interestRate')}</span>
          </Media>
          <Media query={device.down.md}>
            <span>IRS</span>
          </Media>
        </NavLink> */}
            </>
          </RenderForGlobalExchange>
        </div>
        <MediaQuery query={device.down.md}>
          <DeltaButton
            className={styles.searchIconContainer}
            variant="link-t1"
            LinkComponent={Link}
            to={routes.universalSearchMobile}
            data-testid="search-icon-mobile"
            icon={<SearchIcon width={20} height={20} />}
          />
        </MediaQuery>
      </Box>
      {/* SearchBar */}
      <RenderForGlobalExchange>
        <Render
          when={contractType !== 'options_chain' && contractType !== 'options_analytics'}
        >
          <MediaQuery query={device.up.md}>
            <div className={styles.searchContainer}>
              <SearchMarkets
                data-testid="DesktopSearchBar-MarketsPage"
                search={onSearchChange}
                searchValue={searchTerm}
                noProducts={noProducts}
                showLoader={false}
                onClick={handleOnClick}
                reset={reset}
              />
            </div>
          </MediaQuery>
        </Render>
      </RenderForGlobalExchange>
      <RenderForIndianExchange>
        <MediaQuery query={device.up.md}>
          <Box flexDir="row" alignItems="center" className={styles.headerRight} gap={16}>
            <Render when={contractType === 'futures'}>
              <FuturesVolumeBox withBg />
            </Render>
            <Render when={contractType === 'options_chain'}>
              <OptionsVolumeBox withBg />
            </Render>
            <Render when={contractType !== 'tracker'}>
              <DownloadVolumeData />
            </Render>
          </Box>
        </MediaQuery>
      </RenderForIndianExchange>
      {/* SearchBar Mobile */}
      {/* <MediaQuery query={device.down.md}> */}
      {/* <OptionChainNavigation className={'option-chain-all-market-mobile'} /> */}
      {/* {!showFunds && contractType !== 'options_chain' && (
          <Box
            as="div"
            data-testid="goToUniversalSearchMobile-MarketsPage"
            style={{ padding: '10px' }}
            onClick={goToUniversalSearch}>
            <SearchBox
              onSearchChange={onSearchChange}
              searchValue={searchTerm}
              clearSearch={clearSearch}
              disabled
            />
          </Box>
        )} */}
      {/* </MediaQuery> */}
    </div>)
  );
};

MarketsContractTypeHeader.propTypes = {
  // showFunds: PropTypes.bool,
  onSearchChange: PropTypes.func,
  searchTerm: PropTypes.string,
  noProducts: PropTypes.bool,
  handleOnClick: PropTypes.func,
  reset: PropTypes.bool,
  contractType: PropTypes.string,
};

export default MarketsContractTypeHeader;
